import { FC, Suspense } from 'react';
import { PreloadCampaignBanner } from '~/components/campaign-carousel/preload';
import { FirstArticleCardPreload } from './image-preload';
import { DiscoverSmartBanner } from './smart-banner';
import { JsonLD } from '@discover/head/json-ld';
import { SharingCardMeta } from './sharing-card';

export const DiscoverHead: FC = () => {
  return (
    <>
      <DiscoverSmartBanner />
      <PreloadCampaignBanner />
      <SharingCardMeta />
      <FirstArticleCardPreload />
      <JsonLD />
    </>
  );
};
